import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Typography from '@mui/material/Typography'

const PREFIX = 'ChartDataRefetchOnError'

const classes = {
  icon: `${PREFIX}-icon`,
  loadDataBoxAction: `${PREFIX}-loadDataBoxAction`
}

const StyledBox = styled(Box)(({theme}) => ({
  [`& .${classes.icon}`]: {
    color: theme.palette?.graph?.icon
  },

  [`& .${classes.loadDataBoxAction}`]: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.hpBaseDark
  }
}))

function TooltipDataRefetchOnError() {
  const filtersOpen = {}

  return (
    <StyledBox display='flex' flexDirection='column' alignItems='center'>
      <ErrorOutlineIcon
        style={{width: '0.4em', height: '0.4em', fontSize: filtersOpen ? 'calc(80px + 2vh)' : 'calc(80px + 8vh)'}}
        classes={{colorPrimary: classes.icon.color}}
        color='primary'
      />
      <Typography variant='h6' className={classes.loadDataBoxAction} style={{fontSize: filtersOpen ? '75%' : ''}}>
        Something went wrong while fetching data
      </Typography>
    </StyledBox>
  )
}

export default TooltipDataRefetchOnError
